import React, { FC } from "react";
import clsx from "clsx";

import { Radio as MuiRadio, makeStyles } from "@material-ui/core";
import { RadioProps } from "@material-ui/core/Radio";
import { Colors } from "../../styles";

type Props = RadioProps;

const radioStyles = (disabled: boolean): (() => Record<string, string>) =>
    makeStyles({
        root: {
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        icon: {
            borderRadius: "50%",
            width: 30,
            height: 30,
            boxShadow: `inset 0 0 0 1px ${
                disabled ? Colors.anthracite25 : Colors.anthracite25
            }, inset 0 -1px 0 ${disabled ? Colors.anthracite25 : Colors.mellowYellow}`,
            backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
            "$root.Mui-focusVisible &": {
                outline: "2px auto rgba(19,124,189,.6)",
                outlineOffset: 2,
            },
            "input:hover ~ &": {
                backgroundColor: disabled ? "transparent" : Colors.anthracite5,
            },
            "input:disabled ~ &": {
                boxShadow: "none",
                background: "rgba(206,217,224,.5)",
            },
        },
        checkedIcon: {
            backgroundColor: Colors.white,
            backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
            "&:before": {
                width: 30,
                height: 30,
                display: "block",
                backgroundImage: `radial-gradient(${
                    disabled ? Colors.anthracite25 : Colors.mellowYellow
                },${disabled ? Colors.anthracite25 : Colors.mellowYellow} 40%,transparent 32%)`,
                content: '""',
            },
            "input:hover ~ &": {
                backgroundColor: disabled ? "transparent" : Colors.anthracite5,
            },
        },
    });

export const Radio: FC<Props> = (props: Props) => {
    const { disabled, ...other } = props;
    const radioClasses = radioStyles(disabled || false)();

    return (
        <MuiRadio
            className={radioClasses.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(radioClasses.icon, radioClasses.checkedIcon)} />}
            icon={<span className={radioClasses.icon} />}
            {...other}
        />
    );
};
